<template>
  <omint-page>
    <Header name="Busca de rede IA" titleLabel="Busca de rede IA" />
    <omint-slider>
      <router-view />
    </omint-slider>
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";

export default {
  name: "Network-search",
  components: {
    Header
  }
};
</script>
